import * as navigation from 'Navigation';

export default class ProcessDetailsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Task Group',
      closeable: false,
      preferenceKey: 'process-details',
    };
  }
}
